import {
  FETCH_SEARCH_RESULTS,
  LOAD_SEARCH_RESULTS,
  FETCH_DOWNLOAD_LINKS,
  SET_DEFAULT_SEARCH_VALUE,
  SIGN_IN,
  SIGN_OUT,
  FETCH_READING_LIST,
  CLEAR_READING_LIST,
  LOAD_BOOK_DETAILS,
  FETCH_BOOK_DETAILS,
} from "./types";
import googleBooks from "../../apis/googleBooks";
import libgen from "../../apis/libgen";
import history from "../../router/history";
import { database } from "../../firebase.config";

let readingListObserver = null;

export const initiateSearchByQuery = (value) => async () => {
  history.push(`/Search/${value}/1`);
};

export const fetchSearchResults = (value, pageNumber) => async (dispatch) => {
  dispatch({ type: LOAD_SEARCH_RESULTS });
  dispatch({ type: SET_DEFAULT_SEARCH_VALUE, payload: value });

  const startIndex = (pageNumber - 1) * 10;
  const response = await googleBooks.get(
    `/books/v1/volumes?q=${encodeURIComponent(value)}`,
    {
      params: {
        startIndex: startIndex,
      },
    }
  );

  dispatch({ type: FETCH_SEARCH_RESULTS, payload: response.data });
};

export const fetchDownloadLinks = (title, author, bookId) => async (
  dispatch
) => {
  libgen
    .get(
      `/search?search=${(title + " " + author)
        .trim()
        .replace(/ *\([^)]*\) */g, "")
        .split(" ")
        .join("+")}
  &page=1&sort=0&perPage=1&year[]=0&collection=all`
    )
    .then(function (response) {
      dispatch({
        type: FETCH_DOWNLOAD_LINKS,
        payload: { ...response.data, id: bookId },
      });
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const DownloadBook = (bookId) => async (dispatch) => {
  libgen
    .get(`/book/get/${bookId}`)
    .then(function (response) {
      window.open(
        `http://gen.lib.rus.ec/book/index.php?md5=${response.data.md5}`
      );
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const onSignIn = (user) => {
  return {
    type: SIGN_IN,
    payload: user,
  };
};

export const onSignOut = () => {
  return {
    type: SIGN_OUT,
  };
};

export const clearReadingList = () => {
  return {
    type: CLEAR_READING_LIST,
  };
};

export const getUserReadingList = (user) => async (dispatch) => {
  if (readingListObserver) {
    readingListObserver();
  }

  const query = database
    .collection("users")
    .doc(user.uid)
    .collection("ReadingList");

  readingListObserver = query.onSnapshot(
    (querySnapshot) => {
      let readingList = {};

      querySnapshot.forEach((doc) => {
        readingList = { ...readingList, [doc.id]: doc.data() };
      });

      dispatch({
        type: FETCH_READING_LIST,
        payload: readingList,
      });
    },
    (err) => {}
  );
};

export const fetchBookDetails = (bookId) => async (dispatch) => {
  dispatch({ type: LOAD_BOOK_DETAILS });

  const response = await googleBooks.get(`/books/v1/volumes/${bookId}`);

  dispatch({ type: FETCH_BOOK_DETAILS, payload: response.data });
};
